import React from 'react'
import { Link } from 'react-router-dom'
import { IconBrandFacebook, IconBrandInstagram, IconBrandTiktok, IconBrandX } from '@tabler/icons-react'

import './styles/footer.css'

function Footer() {

    const year = new Date();

    return (

        <footer className='--footer'>

            <div className='--content-footer'>

                <div className='--row --row-A'>

                    <div className='--col --col-A'>

                        <h2>Chambita</h2>
                        <Link>+51 966 327 426</Link>
                        <Link>arcanacorp12@gmail.com</Link>

                    </div>

                    <div className='--col --col-B'>
                        <div className='--tit'>
                            <h3>Chambita</h3>
                        </div>
                        <ul className='--nav'>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Nosotros</span>
                                </Link>
                            </li>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Blog</span>
                                </Link>
                            </li>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Guias</span>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className='--col --col-C'>
                        <div className='--tit'>
                            <h3>Empleadores</h3>
                        </div>
                        <ul className='--nav'>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Cuentas</span>
                                </Link>
                            </li>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Obten un trabajo</span>
                                </Link>
                            </li>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Centro de Empleadores</span>
                                </Link>
                            </li>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Centro de Empleos</span>
                                </Link>
                            </li>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Anunciar Empleo</span>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className='--col --col-D'>
                        <div className='--tit'>
                            <h3>Comunidad</h3>
                        </div>
                        <ul className='--nav'>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Ayuda / Contáctanos</span>
                                </Link>
                            </li>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Pautas</span>
                                </Link>
                            </li>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Términos de Uso</span>
                                </Link>
                            </li>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Privacidad y Cookies</span>
                                </Link>
                            </li>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Centro de Privacidad</span>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className='--col --col-E'>
                        <div className='--tit'>
                            <h3>Descargas</h3>
                        </div>
                        <ul className='--nav'>
                            <li className='--li-nav'>
                                <Link className='--a-nav'>
                                    <span>Pronto Disponible</span>
                                </Link>
                            </li>
                        </ul>
                    </div>

                </div>

                <div className='--row --row-B'>

                    <div className='--row-B-A'>
                        <ul className='--networks'>
                            <li className='--network'>
                                <Link to={'/'} className='--a-network'>
                                    <IconBrandFacebook/>
                                </Link>
                            </li>
                            <li className='--network'>
                                <Link to={'/'} className='--a-network'>
                                    <IconBrandInstagram/>
                                </Link>
                            </li>
                            <li className='--network'>
                                <Link to={'/'} className='--a-network'>
                                    <IconBrandX/>
                                </Link>
                            </li>
                            <li className='--network'>
                                <Link to={'/'} className='--a-network'>
                                    <IconBrandTiktok/>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className='--row-B-B'>
                        <span> © {year.getFullYear()} - Chambita.com</span>
                    </div>

                </div>

            </div>

        </footer>

    )

}

export default Footer